// Copies plain text to the system clipboard. Tries the modern Async
// Clipboard API first (requires secure context: https or localhost), then
// falls back to the legacy `document.execCommand('copy')` path. Throws if
// neither is available.
//
// In iframe contexts (4.M embed mode) the modern API requires the parent
// page to grant permission via `allow="clipboard-write"`. The legacy path
// works in more iframes but is deprecated; we keep it as defense-in-depth.
export async function copyText(text: string): Promise<void> {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch (err) {
      console.warn('[clipboard] modern API failed, falling back:', err);
    }
  }
  if (typeof document === 'undefined') {
    throw new Error('Clipboard non disponibile (no document)');
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.cssText = 'position:fixed;top:-1000px;left:-1000px;opacity:0';
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  } finally {
    ta.remove();
  }
  if (!ok) {
    throw new Error('Clipboard non disponibile (execCommand fallito)');
  }
}
